import React from "react";
import { Typography, Grid } from "@material-ui/core";
import PropTypes from "prop-types";

import { useStyles } from "./styles";

export default function BannerLabel(props) {
  const classes = useStyles();
  return (
    <Grid item className={classes.root}>
      <Typography variant="h4" component="h4">
        {props.headerTitle}
      </Typography>
      {/* <hr className={classes.divider} /> */}
      <Typography variant="h6" gutterBottom>
        {props.subTitle}
      </Typography>
    </Grid>
  );
}

BannerLabel.propTypes = {
  headerTitle: PropTypes.string,
  subTitle: PropTypes.string
};
